export enum BetaReaderStatus {
    //SEEKING_READERS = "Seeking-Readers", // This is for new projects - remove
    ACTIVE = "Active",
    BETA_READER_ENDED = "Beta-Reader-Ended", //change to betaReaderEnded
    WRITER_ENDED = "Writer-Ended" //change to writerEnded

    
}

export enum ProjectMatchStatus {
    MATCHED = "Matched",
    BETA_READER_REJECTED = "Beta-Reader-Rejected", //beta reader rejects project
    BETA_READER_REQUEST_ACCEPTANCE = "Beta-Reader-Request-Acceptance",
    WRITER_REJECTED = "Writer-Rejected", //writer rejects beta reader
    ACTIVE = "Active",
    UNMATCHED = "Unmatched"
}

export enum WriterStatus {
    ACTIVE = "Active",
    NOT_INTERESTED = "Not-Interested",
    PENDING_RESPONSE = "Pending-Response"
}

export enum PlatformRole {
    WRITER = "Writers",
    BETAREADER = "BetaReaders"
}

export enum SecureRole {
    SUPERADMIN = "RuneAndGearAdmin",
    DEVELOPER = "Developer"
}

export enum ProjectDescriptorType {
    TEXT= "TEXT",
    CHECKBOXES = "CHECKBOXES",
    LONGTEXT = "LONGTEXT",
    NUMBER = "NUMBER",
    RADIO_BUTTONS = "RADIO_BUTTONS",
    DROPDOWN = "DROPDOWN",
    MULTISELECT = "MULTISELECT"
}

export enum ProjectDescriptorUse {
    WRITER_PROJECT = "WRITER_PROJECT",
    BETA_READER_PROFILE = "BETA_READER_PROFILE",
    BETA_READER_VIEW_OF_PROJECT = "BETA_READER_VIEW_OF_PROJECT",
    WRITER_VIEW_OF_BETA_READER_PROFILE = "WRITER_VIEW_OF_BETA_READER_PROFILE",
}

export enum BetaReaderMatchUse {
    DO_NOT_USE_TO_MATCH= "DO_NOT_USE_TO_MATCH",
    MUST_MATCH_AT_LEAST_ONE = "MUST_MATCH_AT_LEAST_ONE",
    MUST_NOT_MATCH_ANY = "MUST_NOT_MATCH_ANY",
    BAD_SCORE_ON_MATCH = "BAD_SCORE_ON_MATCH", //If there is a match on this category between the reader and project, reduce the project score by the weight
    GOOD_SCORE_ON_MATCH = "GOOD_SCORE_ON_MATCH"
}

